var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M17 9H7L12 14L17 9Z","fill":"#495057"}})])}
var staticRenderFns = []

export { render, staticRenderFns }